<template>
  <div v-show="visible" @click.stop="$emit('click')"></div>
</template>

<script>

  export default {
    name: 'v-shadow',
    props: {
      zIndex: {
        type: Number
      },
      backgroundColor: {
        type:String,
        default: 'rgba(0, 0, 0, 0.5)'
      }
    },
    data() {
      return {
        visible: false
      };
    },
    methods: {
      show() {
        this.visible = true;
      },
      hide() {
        this.visible = false;
      }
    }
  };
</script>

<style lang="scss">
  .v-shadow {
    height: 100vh;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    box-sizing: border-box;
  }
</style>
